import React from 'react';

const ManagedPrintsPageConfig = {
	settings: {
		layout: {
			config: {
				adminPage: true,
			},
		},
	},
	routes: [
		{
			path: '/admin/manage-qs',
			exact: true,
			component: React.lazy(() => import('./ManagedPrintsPage')),
		},
		{
			path: '/admin/manage-qs-direct',
			exact: true,
			component: React.lazy(() => import('./ManagedPrintsPage')),
		},
	],
};

export default ManagedPrintsPageConfig;
